import React, { useEffect, useState } from 'react'
import {
  findImageGroupBy,
  getImageFromImageGroup,
  ProductImage
} from 'msp-integrations'
import useProduct from '@/hooks/use-product'

import * as S from './AccountOverviewWishlist.styles'

const WishlistItem = ({ productId }: { productId: string }) => {
  const product = useProduct(productId)
  const [productImage, setProductImage] = useState<ProductImage>()

  useEffect(() => {
    if (product?.imageGroups) {
      const largeImageGroup = findImageGroupBy(product.imageGroups, {
        viewType: 'large',
        selectedVariationAttributes: {}
      })

      setProductImage({
        link: getImageFromImageGroup(largeImageGroup, 0, {
          scaleWidth: 75
        }),
        alt: largeImageGroup?.images[0]?.alt
      })
    }
  }, [product?.imageGroups])

  return (
    <>
      {productImage && (
        <div key={`product-img-${product.id}`} className={S.WishlistItem}>
          <img alt={productImage.alt} src={productImage.link} />
        </div>
      )}
    </>
  )
}

export default WishlistItem
